import { VyStack } from '@vy/ui-design-system';
import { BillingMeteringSection, ProductSettingsSection, SchedulingSection, UpgradeOptionsSection } from '../sections';

export function PerUnitVariant() {
  return (
    <VyStack sx={{ gap: 2.5 }}>
      <ProductSettingsSection />
      <SchedulingSection />
      <BillingMeteringSection showBulkSizeField />
      <UpgradeOptionsSection />
    </VyStack>
  );
}
